import * as React from 'react';
import './modalGroup.scss';

export const ModalGroups = ({
  children,
  id
}: Pick<React.HTMLAttributes<HTMLDivElement>, 'children' | 'id'>) => (
  <div id={id} className="modal-groups">
    {children}
  </div>
);

export const ModalGroup = ({
  children,
  label,
  text,
  id
}: Pick<React.HTMLAttributes<HTMLDivElement>, 'children' | 'id'> & {
  label?: any;
  text?: any;
}) => {
  return (
    <div className="modal-group" id={id}>
      {!!label && <h6>{label}</h6>}
      {!!text && <p>{text}</p>}
      <div className="modal-children-container">{children}</div>
    </div>
  );
};
